module.exports = __webpack_public_path__ + "media/images/default/background-image-2968370ee3096414455d0cd18e2db57c.png";